import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import AllRoutes from './routes';
import { RootState } from './redux/store';
import { useEffect } from 'react';
import { fetchRolePermissions } from './redux/slices/authSlice';
import { Backdrop, CircularProgress } from '@mui/material';
import theme from './theme/theme';

function App() {
  const dispatch = useDispatch<any>();
  const user = useSelector((state: RootState) => state.auth.user);
  const { isAuthenticated, loading } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (isAuthenticated && user?.role_id && user?.force_change_password) {
      dispatch(fetchRolePermissions(user.role_id)); // Fetch permissions when the app loads
    }
  }, [dispatch, isAuthenticated, user, user?.force_change_password]);

  if (loading && isAuthenticated && user?.force_change_password) {
    return <Backdrop
      sx={{ color: theme.palette.primary.contrastText, zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>; // You can customize this to a more suitable loader or spinner
  }

  return (
    <AllRoutes />
  );
}

export default App;
